import alignLeft from "@phosphor-icons/core/regular/align-left.svg?raw";
import arrowBendUpLeft from "@phosphor-icons/core/regular/arrow-bend-up-left.svg?raw";
import arrowBendUpRight from "@phosphor-icons/core/regular/arrow-bend-up-right.svg?raw";
import arrowDown from "@phosphor-icons/core/regular/arrow-down.svg?raw";
import arrowUp from "@phosphor-icons/core/regular/arrow-up.svg?raw";
import arrowsCounterClockwise from "@phosphor-icons/core/regular/arrows-counter-clockwise.svg?raw";
import arrowsDownUp from "@phosphor-icons/core/regular/arrows-down-up.svg?raw";
import arrowsInLineVertical from "@phosphor-icons/core/regular/arrows-in-line-vertical.svg?raw";
import arrowsOutLineVertical from "@phosphor-icons/core/regular/arrows-out-line-vertical.svg?raw";
import broom from "@phosphor-icons/core/regular/broom.svg?raw";
import caretDown from "@phosphor-icons/core/regular/caret-down.svg?raw";
import caretRight from "@phosphor-icons/core/regular/caret-right.svg?raw";
import check from "@phosphor-icons/core/regular/check.svg?raw";
import code from "@phosphor-icons/core/regular/code.svg?raw";
import dotsSix from "@phosphor-icons/core/regular/dots-six.svg?raw";
import dotsThreeVertical from "@phosphor-icons/core/regular/dots-three-vertical.svg?raw";
import eye from "@phosphor-icons/core/regular/eye.svg?raw";
import link from "@phosphor-icons/core/regular/link.svg?raw";
import listNumbers from "@phosphor-icons/core/regular/list-numbers.svg?raw";
import listPlus from "@phosphor-icons/core/regular/list-plus.svg?raw";
import pencilSimpleLine from "@phosphor-icons/core/regular/pencil-simple-line.svg?raw";
import pushPin from "@phosphor-icons/core/regular/push-pin.svg?raw";
import question from "@phosphor-icons/core/regular/question.svg?raw";
import sigma from "@phosphor-icons/core/regular/sigma.svg?raw";
import splitHorizontal from "@phosphor-icons/core/regular/split-horizontal.svg?raw";
import textAlignCenter from "@phosphor-icons/core/regular/text-align-center.svg?raw";
import textAlignJustify from "@phosphor-icons/core/regular/text-align-justify.svg?raw";
import textAlignLeft from "@phosphor-icons/core/regular/text-align-left.svg?raw";
import textAlignRight from "@phosphor-icons/core/regular/text-align-right.svg?raw";
import textB from "@phosphor-icons/core/regular/text-b.svg?raw";
import textColumns from "@phosphor-icons/core/regular/text-columns.svg?raw";
import textIndent from "@phosphor-icons/core/regular/text-indent.svg?raw";
import textItalic from "@phosphor-icons/core/regular/text-italic.svg?raw";
import textOutdent from "@phosphor-icons/core/regular/text-outdent.svg?raw";
import x from "@phosphor-icons/core/regular/x.svg?raw";

import rowGroups from "../../assets/icons/generic/row-groups.svg?raw";
import textItalicX from "../../assets/icons/generic/text-italic-x.svg?raw";
import type { IconName } from "./iconNames.generated";

/** The icons AG Grid and TinyMCE take as markup instead of a component. */
const RAW_ICONS = {
  "generic/row-groups": rowGroups,
  "generic/text-italic-x": textItalicX,
  "phosphor/align-left": alignLeft,
  "phosphor/arrow-bend-up-left": arrowBendUpLeft,
  "phosphor/arrow-bend-up-right": arrowBendUpRight,
  "phosphor/arrow-down": arrowDown,
  "phosphor/arrow-up": arrowUp,
  "phosphor/arrows-counter-clockwise": arrowsCounterClockwise,
  "phosphor/arrows-down-up": arrowsDownUp,
  "phosphor/arrows-in-line-vertical": arrowsInLineVertical,
  "phosphor/arrows-out-line-vertical": arrowsOutLineVertical,
  "phosphor/broom": broom,
  "phosphor/caret-down": caretDown,
  "phosphor/caret-right": caretRight,
  "phosphor/check": check,
  "phosphor/code": code,
  "phosphor/dots-six": dotsSix,
  "phosphor/dots-three-vertical": dotsThreeVertical,
  "phosphor/eye": eye,
  "phosphor/link": link,
  "phosphor/list-numbers": listNumbers,
  "phosphor/list-plus": listPlus,
  "phosphor/pencil-simple-line": pencilSimpleLine,
  "phosphor/push-pin": pushPin,
  "phosphor/question": question,
  "phosphor/sigma": sigma,
  "phosphor/split-horizontal": splitHorizontal,
  "phosphor/text-align-center": textAlignCenter,
  "phosphor/text-align-justify": textAlignJustify,
  "phosphor/text-align-left": textAlignLeft,
  "phosphor/text-align-right": textAlignRight,
  "phosphor/text-b": textB,
  "phosphor/text-columns": textColumns,
  "phosphor/text-indent": textIndent,
  "phosphor/text-italic": textItalic,
  "phosphor/text-outdent": textOutdent,
  "phosphor/x": x,
} satisfies Partial<Record<IconName, string>>;

export type RawIconName = keyof typeof RAW_ICONS;

export const RAW_ICON_NAMES = Object.keys(RAW_ICONS) as RawIconName[];

/** The icon's SVG at `size` px, painted with `currentColor` whatever size and fill its file sets. */
export const iconMarkup = (name: RawIconName, size = 16): string =>
  RAW_ICONS[name].replace(
    /<svg\b([^>]*)>/,
    (_tag, attributes: string) =>
      `<svg${attributes.replace(/\s(?:width|height|fill)="[^"]*"/g, "")} width="${size}" height="${size}" fill="currentColor">`,
  );

/** {@link iconMarkup} as a `data:` URL, for AG Grid's image icons and CSS masks. */
export const iconDataUrl = (name: RawIconName, size = 16): string =>
  `data:image/svg+xml;utf8,${encodeURIComponent(iconMarkup(name, size))}`;
